<template>
  <div id="LogisticsMgmt" class="purchase-mgmt-page">
    <div class="page-header">
      <div class="filter-card">
        <div class="filter-row">
          <div class="filter-item">
            <span class="filter-label">采购日期</span>
            <el-date-picker
              v-model="dateRange"
              size="small"
              type="daterange"
              range-separator="至"
              start-placeholder="开始"
              end-placeholder="结束"
              class="filter-date"
            ></el-date-picker>
          </div>
          <div class="filter-item">
            <span class="filter-label">产品类型</span>
            <el-select v-model="params.productType" size="small" filterable clearable placeholder="全部">
              <el-option
                v-for="product in productList"
                :key="product.productType"
                :label="product.productName"
                :value="product.productType"
              ></el-option>
            </el-select>
          </div>
          <div class="filter-item">
            <span class="filter-label">供应商</span>
            <el-select v-model="params.supplierId" size="small" filterable clearable placeholder="全部">
              <el-option
                v-for="supplier in supplierList"
                :key="supplier.supplierId"
                :label="supplier.supplierShortName"
                :value="supplier.supplierId"
              ></el-option>
            </el-select>
          </div>
          <div class="filter-item">
            <span class="filter-label">物流公司</span>
            <el-select v-model="params.logisticsCompany" size="small" filterable clearable placeholder="全部">
              <el-option v-for="name in logisticsCompanies" :key="name" :label="name" :value="name"></el-option>
            </el-select>
          </div>
          <div class="filter-item">
            <span class="filter-label">物流单号</span>
            <el-input v-model="params.logisticsNo" size="small" clearable placeholder="请输入物流单号"></el-input>
          </div>
          <div class="filter-item">
            <span class="filter-label">运单号</span>
            <el-input v-model="params.waybillNo" size="small" clearable placeholder="请输入运单号"></el-input>
          </div>
          <div class="filter-item">
            <span class="filter-label">收货状态</span>
            <el-select v-model="params.receiveStatus" size="small" clearable placeholder="全部">
              <el-option label="未收货" :value="0"></el-option>
              <el-option label="已收货" :value="1"></el-option>
            </el-select>
          </div>
          <div class="filter-item">
            <el-button type="primary" size="small" icon="el-icon-search" @click="queryBtn">查询</el-button>
            <el-button type="primary" size="small" icon="el-icon-plus" plain @click="openAddDialog">新增</el-button>
            <el-button type="success" size="small" icon="el-icon-upload2" plain @click="openReceiveUploadDialog">上传收货图</el-button>
          </div>
        </div>
      </div>
    </div>

    <div class="table-panel" ref="tablePanel">
      <div class="table-container">
        <el-table
          ref="table"
          :data="tableData"
          border
          stripe
          size="mini"
          :height="screenHeight"
          v-loading="loading"
          element-loading-text="加载中..."
          :row-key="getTableRowKey"
          :span-method="spanMethod"
          :cell-class-name="tableCellClassName"
          header-cell-class-name="table-header-cell"
          class="mgmt-table logistics-mgmt-table"
        >
          <el-table-column label="序号" width="50" align="center" fixed="left" class-name="merge-col">
            <template slot-scope="scope">
              <span v-if="scope.row._orderRowSpan > 0">{{ getLogisticsRowIndex(scope.row) }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="date" label="采购日期" width="100" align="center" fixed="left" class-name="merge-col"></el-table-column>
                    <el-table-column prop="receiveStatusLabel" label="收货状态" width="80" align="center" class-name="merge-col">
            <template slot-scope="scope">
              <el-tag
                v-if="scope.row.receiveStatusLabel"
                size="mini"
                :type="~~scope.row.receiveStatus === 1 ? 'success' : 'info'"
                effect="plain"
              >
                {{ scope.row.receiveStatusLabel }}
              </el-tag>
              <span v-else class="proof-empty">-</span>
            </template>
          </el-table-column>
          <el-table-column prop="orderNo" label="采购单号" width="150" align="center" class-name="merge-col" show-overflow-tooltip></el-table-column>
          <el-table-column prop="shopName" label="店铺" width="60" align="center" class-name="merge-col" show-overflow-tooltip></el-table-column>
          <el-table-column prop="supplierName" label="供应商名称" width="120" class-name="merge-col" show-overflow-tooltip></el-table-column>
          <el-table-column prop="productName" label="产品名称" width="220" show-overflow-tooltip></el-table-column>
          <el-table-column prop="unitPrice" label="单价" width="70" align="right" class-name="amount-col">
            <template slot-scope="scope">{{ formatAmount(scope.row.unitPrice) }}</template>
          </el-table-column>
          <el-table-column prop="quantity" label="采购数量" width="80" align="right" class-name="amount-col">
            <template slot-scope="scope">{{ formatQuantity(scope.row.quantity) }}</template>
          </el-table-column>
          <el-table-column prop="actualPaidAmount" label="实付金额" width="80" align="right" class-name="merge-col amount-col">
            <template slot-scope="scope">{{ formatAmount(scope.row.actualPaidAmount) }}</template>
          </el-table-column>
          <el-table-column prop="logisticsCompany" label="物流公司" width="110" align="center" class-name="merge-col" show-overflow-tooltip></el-table-column>

          <el-table-column prop="logisticsNo" label="物流编号" min-width="150" align="left" class-name="merge-col logistics-no-col">
            <template slot-scope="scope">
              <div v-if="getLogisticsNoList(scope.row).length" class="logistics-no-list">
                <div v-for="(no, index) in getLogisticsNoList(scope.row)" :key="no + '-' + index" class="logistics-no-item">
                  {{ no }}
                </div>
              </div>
              <span v-else class="proof-empty">-</span>
            </template>
          </el-table-column>
          <el-table-column prop="boxCount" label="物流箱子数" width="90" align="right" class-name="merge-col amount-col">
            <template slot-scope="scope">{{ formatQuantity(scope.row.boxCount) }}</template>
          </el-table-column>
          <el-table-column prop="waybillNo" label="运单号" width="180" class-name="merge-col" show-overflow-tooltip>
            <template slot-scope="scope">{{ formatWaybillNos(scope.row) }}</template>
          </el-table-column>
          <el-table-column label="供应商物流面单照片" width="150" align="center" class-name="merge-col">
            <template slot-scope="scope">
              <div v-if="getImageList(scope.row.supplierWaybillPhotos).length" class="proof-thumb-list">
                <el-image
                  v-for="(url, index) in getImageList(scope.row.supplierWaybillPhotos)"
                  :key="url + '-' + index"
                  :src="url"
                  :preview-src-list="getImageList(scope.row.supplierWaybillPhotos)"
                  fit="cover"
                  class="proof-thumb"
                ></el-image>
              </div>
              <span v-else class="proof-empty">-</span>
            </template>
          </el-table-column>
          <el-table-column label="收货物流图片" width="140" align="center" class-name="merge-col">
            <template slot-scope="scope">
              <div v-if="getImageList(scope.row.receiveLogisticsImages).length" class="proof-thumb-list">
                <el-image
                  v-for="(url, index) in getImageList(scope.row.receiveLogisticsImages)"
                  :key="url + '-' + index"
                  :src="url"
                  :preview-src-list="getImageList(scope.row.receiveLogisticsImages)"
                  fit="cover"
                  class="proof-thumb"
                ></el-image>
              </div>
              <span v-else class="proof-empty">-</span>
            </template>
          </el-table-column>
          <el-table-column prop="createTime" label="创建时间" width="140" align="center" class-name="merge-col">
            <template slot-scope="scope">{{ formatCreateTime(scope.row.createTime) }}</template>
          </el-table-column>
          <el-table-column prop="remark" label="备注" min-width="120" class-name="merge-col" show-overflow-tooltip>
            <template slot-scope="scope">{{ scope.row.remark || "-" }}</template>
          </el-table-column>
          <el-table-column label="操作" width="140" align="center" fixed="right" class-name="merge-col">
            <template slot-scope="scope">
              <div v-if="scope.row._orderRowSpan > 0" class="action-cell">
                <el-button type="text" size="mini" @click="openEditDialog(scope.row)">编辑</el-button>
                <el-button type="text" size="mini" @click="showOpreateLog(scope.row)">操作记录</el-button>
              </div>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div class="pagination-box">
        <el-pagination
          layout="prev, pager, next"
          background
          prev-text="上一页"
          next-text="下一页"
          :current-page.sync="currentPage"
          :page-size="params.pageSize"
          :total="total"
          @current-change="onPageChange"
        ></el-pagination>
      </div>
    </div>

    <el-dialog
      :title="dialogMode === 'edit' ? '编辑物流' : '新增物流'"
      :visible.sync="addDialogVisible"
      width="860px"
      custom-class="logistics-add-dialog"
      :close-on-click-modal="false"
      @opened="onAddDialogOpened"
      @closed="onAddDialogClosed"
    >
      <el-form ref="addForm" :model="addForm" :rules="addRules" label-width="140px" size="small">
        <el-form-item label="采购单号" prop="orderNo">
          <el-input v-model="addForm.orderNo" clearable placeholder="请输入采购单号" maxlength="100"></el-input>
        </el-form-item>
        <el-form-item label="采购日期" prop="date">
          <el-date-picker v-model="addForm.date" type="date" value-format="yyyy-MM-dd" placeholder="请选择采购日期" style="width: 100%"></el-date-picker>
        </el-form-item>
        <el-form-item label="店铺">
          <el-input v-model="addForm.shopName" clearable placeholder="请输入店铺" maxlength="50"></el-input>
        </el-form-item>
        <el-form-item label="实付金额">
          <el-input v-model="addForm.actualPaidAmount" clearable placeholder="请输入实付金额"></el-input>
        </el-form-item>
        <el-form-item label="产品明细" required>
          <logistics-product-lines-editor ref="productLinesEditor" v-model="addForm.productLines" :product-list="productList" />
        </el-form-item>
        <el-form-item label="供应商" prop="supplierId">
          <el-select v-model="addForm.supplierId" filterable clearable placeholder="请选择供应商" style="width: 100%" @change="onAddSupplierChange">
            <el-option
              v-for="supplier in supplierList"
              :key="supplier.supplierId"
              :label="supplier.supplierShortName"
              :value="supplier.supplierId"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="供应商物流面单照片">
          <logistics-waybill-upload-panel
            ref="supplierWaybillPanel"
            :photos.sync="addForm.supplierWaybillPhotos"
            :active="pasteTarget === 'supplier'"
            :upload-pending="proofUploadPending"
            :barcode-recognizing="barcodeRecognizing"
            @focus-panel="setPasteTarget('supplier')"
            @upload-start="markProofUploadStart"
            @upload-end="markProofUploadEnd"
            @barcode-start="markBarcodeRecognizingStart"
            @barcode-end="markBarcodeRecognizingEnd"
            @barcode-result="applyBarcodeRecognition"
          />
        </el-form-item>
        <el-form-item label="物流单号" prop="logisticsNos">
          <el-select
            v-model="addForm.logisticsNos"
            multiple
            filterable
            allow-create
            default-first-option
            clearable
            placeholder="输入物流单号后回车添加，可添加多个"
            style="width: 100%"
          >
            <el-option v-for="no in addForm.logisticsNos" :key="no" :label="no" :value="no"></el-option>
          </el-select>
          <div class="form-item-tip">支持多个物流单号，上传面单后自动识别并合并</div>
        </el-form-item>
        <el-form-item label="物流箱子数" prop="boxCount">
          <el-input-number
            v-model="addForm.boxCount"
            class="box-count-input"
            :min="0"
            :precision="0"
            :controls="false"
            placeholder="请输入物流箱子数"
            style="width: 100%"
          ></el-input-number>
        </el-form-item>
        <el-form-item label="运单号" prop="waybillNos">
          <el-select
            v-model="addForm.waybillNos"
            multiple
            filterable
            allow-create
            default-first-option
            clearable
            placeholder="输入运单号后回车添加，可添加多个"
            style="width: 100%"
          >
            <el-option v-for="no in addForm.waybillNos" :key="no" :label="no" :value="no"></el-option>
          </el-select>
          <div class="form-item-tip">支持多个运单号，输入后回车确认</div>
        </el-form-item>
        <el-form-item label="物流公司" prop="logisticsCompany">
          <el-select v-model="addForm.logisticsCompany" filterable clearable placeholder="请选择物流公司" style="width: 100%">
            <el-option v-for="name in logisticsCompanies" :key="name" :label="name" :value="name"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="收货物流图片">
          <div
            class="proof-upload-panel"
            :class="{ 'is-paste-active': pasteTarget === 'receive' }"
            tabindex="0"
            v-loading="proofUploading"
            @click="setPasteTarget('receive')"
            @focus="setPasteTarget('receive')"
          >
            <div class="proof-upload-list">
              <div v-for="(url, index) in addForm.receiveLogisticsImages" :key="'rl-' + url + '-' + index" class="proof-upload-item">
                <el-image :src="url" fit="cover" class="proof-upload-image" :preview-src-list="addForm.receiveLogisticsImages"></el-image>
                <i class="el-icon-error proof-upload-remove" @click="addForm.receiveLogisticsImages.splice(index, 1)"></i>
              </div>
              <el-upload
                class="proof-upload-add"
                action="/biz/oss/upload"
                name="file"
                accept="image/*"
                multiple
                :data="{ bizModule: 'logistic' }"
                :show-file-list="false"
                :before-upload="beforeReceiveLogisticsUpload"
                :on-success="handleReceiveLogisticsUploadSuccess"
                :on-error="handleProofUploadError"
                :disabled="proofUploading"
              >
                <div class="proof-upload-trigger">
                  <i class="el-icon-plus"></i>
                  <span class="proof-upload-text">添加图片</span>
                </div>
              </el-upload>
            </div>
            <div class="proof-upload-tip">支持多选上传；点击本区域后可 Ctrl+V 粘贴图片；有收货图时状态自动为已收货，删光后回退为未收货</div>
          </div>
        </el-form-item>
        <el-form-item label="备注" prop="remark">
          <el-input v-model="addForm.remark" type="textarea" :rows="3" maxlength="500" show-word-limit placeholder="请输入备注"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="addDialogVisible = false">取 消</el-button>
        <el-button type="primary" :loading="addSaving" @click="submitForm">确 定</el-button>
      </div>
    </el-dialog>

    <el-dialog
      title="上传收货图"
      :visible.sync="receiveUploadDialogVisible"
      width="760px"
      custom-class="receive-upload-dialog"
      :close-on-click-modal="false"
      @opened="onReceiveUploadDialogOpened"
      @closed="onReceiveUploadDialogClosed"
    >
      <div
        class="receive-upload-panel"
        tabindex="0"
        v-loading="receiveUploadProcessing"
        element-loading-text="正在处理收货图…"
        @click="receiveUploadPasteActive = true"
        @focus="receiveUploadPasteActive = true"
      >
        <el-upload
          class="receive-upload-picker"
          action="#"
          accept="image/*"
          multiple
          :auto-upload="false"
          :show-file-list="false"
          :disabled="receiveUploadProcessing"
          :on-change="onReceiveFileChange"
        >
          <el-button size="small" type="primary" plain icon="el-icon-plus" :disabled="receiveUploadProcessing">
            选择图片
          </el-button>
        </el-upload>
        <span class="receive-upload-tip">支持多选；点击本区域后可 Ctrl+V 粘贴图片</span>
        <div v-if="receiveUploadPendingFiles.length" class="receive-pending-list">
          <div v-for="(item, index) in receiveUploadPendingFiles" :key="item.uid" class="receive-pending-item">
            <el-image v-if="item.previewUrl" :src="item.previewUrl" fit="cover" class="receive-pending-thumb"></el-image>
            <span class="receive-pending-name">{{ item.name }}</span>
            <el-button
              v-if="!receiveUploadProcessing"
              type="text"
              size="mini"
              icon="el-icon-close"
              @click="removeReceivePendingFile(index)"
            ></el-button>
          </div>
        </div>
        <div v-if="receiveUploadResults.length" class="receive-result-section">
          <div class="receive-result-title">处理结果</div>
          <el-table :data="receiveUploadResults" border size="mini" max-height="220">
            <el-table-column label="缩略图" width="72" align="center">
              <template slot-scope="scope">
                <el-image
                  v-if="scope.row.previewUrl"
                  :src="scope.row.previewUrl"
                  fit="cover"
                  class="receive-result-thumb"
                  :preview-src-list="[scope.row.previewUrl]"
                ></el-image>
              </template>
            </el-table-column>
            <el-table-column prop="logisticsNo" label="物流单号" min-width="140" show-overflow-tooltip></el-table-column>
            <el-table-column prop="matchCount" label="匹配条数" width="80" align="center"></el-table-column>
            <el-table-column prop="appendedCount" label="追加条数" width="80" align="center"></el-table-column>
            <el-table-column prop="statusLabel" label="状态" width="100" align="center"></el-table-column>
            <el-table-column prop="message" label="说明" min-width="160" show-overflow-tooltip></el-table-column>
          </el-table>
        </div>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="receiveUploadDialogVisible = false" :disabled="receiveUploadProcessing">关 闭</el-button>
        <el-button
          type="primary"
          :loading="receiveUploadProcessing"
          :disabled="!receiveUploadPendingFiles.length"
          @click="startReceiveUploadProcess"
        >
          开始上传并匹配
        </el-button>
      </div>
    </el-dialog>

    <el-dialog
      title="匹配确认"
      :visible.sync="matchConfirmVisible"
      width="820px"
      custom-class="receive-match-dialog"
      :close-on-click-modal="false"
      append-to-body
      @closed="onMatchConfirmDialogClosed"
    >
      <div v-loading="matchConfirmRematching">
        <div class="receive-match-summary">
          <div class="receive-match-preview">
            <el-image
              v-if="matchConfirmContext.previewUrl"
              :src="matchConfirmContext.previewUrl"
              fit="cover"
              class="receive-match-thumb"
              :preview-src-list="[matchConfirmContext.previewUrl]"
            ></el-image>
          </div>
          <div class="receive-match-meta">
            <div class="receive-match-progress">
              第 {{ matchConfirmContext.index }} / {{ matchConfirmContext.total }} 张
            </div>
            <el-form label-width="80px" size="small" @submit.native.prevent>
              <el-form-item label="物流单号">
                <el-input
                  v-model="matchConfirmContext.logisticsNo"
                  clearable
                  placeholder="识别失败可手动输入"
                  @keyup.enter.native="onMatchConfirmRematch"
                >
                  <el-button slot="append" :loading="matchConfirmRematching" @click="onMatchConfirmRematch">重新匹配</el-button>
                </el-input>
              </el-form-item>
            </el-form>
            <div v-if="matchConfirmContext.matchList.length" class="receive-match-tip">
              匹配到 {{ matchConfirmContext.matchList.length }} 条物流记录，确认后将把当前图片追加到以下全部记录的「收货物流图片」。
            </div>
            <div v-else class="receive-match-tip is-warning">未找到包含该单号的物流记录，请修正单号后重新匹配，或跳过本张。</div>
          </div>
        </div>
        <el-table :data="matchConfirmContext.matchList" border size="mini" max-height="280">
          <el-table-column type="index" label="序号" width="50" align="center"></el-table-column>
          <el-table-column prop="orderNo" label="采购单号" min-width="130" show-overflow-tooltip></el-table-column>
          <el-table-column prop="date" label="采购日期" width="100" align="center"></el-table-column>
          <el-table-column prop="supplierName" label="供应商" min-width="110" show-overflow-tooltip></el-table-column>
          <el-table-column prop="productName" label="产品名称" min-width="120" show-overflow-tooltip></el-table-column>
          <el-table-column label="已有收货图" width="90" align="center">
            <template slot-scope="scope">{{ getImageList(scope.row.receiveLogisticsImages).length }} 张</template>
          </el-table-column>
        </el-table>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="onMatchConfirmSkip">跳过本张</el-button>
        <el-button
          type="primary"
          :disabled="!matchConfirmContext.matchList.length"
          @click="onMatchConfirmConfirm"
        >
          确认追加到以上 {{ matchConfirmContext.matchList.length }} 条记录
        </el-button>
      </div>
    </el-dialog>

    <el-dialog title="操作记录" :visible.sync="opreateLogVisible" width="960px">
      <el-table :data="operateHistory" border stripe size="mini" max-height="420" v-loading="opreateLogLoading">
        <el-table-column label="序号" width="50" align="center">
          <template slot-scope="scope">{{ scope.$index + 1 }}</template>
        </el-table-column>
        <el-table-column prop="opreateUserName" label="操作人" width="90"></el-table-column>
        <el-table-column prop="opreateTimeLabel" label="操作时间" width="170"></el-table-column>
        <el-table-column prop="opreateTypeLabel" label="操作类型" width="120"></el-table-column>
        <el-table-column prop="bussinessId" label="业务ID" width="160" show-overflow-tooltip></el-table-column>
        <el-table-column prop="content" label="操作详情" min-width="240" show-overflow-tooltip></el-table-column>
      </el-table>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="opreateLogVisible = false">关 闭</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { logisticsModules, requestModules, ossModules } from "@r";
import { activeProducts, allActiveProducts } from "../../utils/constant.js";
import LogisticsProductLinesEditor from "./LogisticsProductLinesEditor.vue";
import LogisticsWaybillUploadPanel from "./LogisticsWaybillUploadPanel.vue";
import {
  LOGISTICS_COMPANIES,
  createEmptyLogisticsForm,
  normalizeProductLinesFromRow,
  normalizeStringList,
  serializeProductLinesForSubmit,
} from "../../utils/logisticsFormHelpers";

function createEmptyMatchConfirmContext() {
  return {
    imageUrl: "",
    previewUrl: "",
    logisticsNo: "",
    matchList: [],
    index: 0,
    total: 0,
  };
}

function normalizeWaybillNos(value) {
  return normalizeStringList(value);
}

const LOGISTICS_MERGE_PROPS = [
  "date",
  "orderNo",
  "shopName",
  "supplierName",
  "actualPaidAmount",
  "logisticsCompany",
  "receiveStatusLabel",
  "logisticsNo",
  "waybillNo",
  "createTime",
  "remark",
];
const LOGISTICS_MERGE_LABELS = ["序号", "供应商物流面单照片", "收货物流图片", "操作"];

export default {
  name: "LogisticsMgmt",
  components: {
    LogisticsProductLinesEditor,
    LogisticsWaybillUploadPanel,
  },
  data() {
    return {
      loading: false,
      tableData: [],
      total: 0,
      currentPage: 1,
      screenHeight: document.body.clientHeight - 64 - 120 - 60,
      dateRange: [],
      productList: localStorage.getItem("shopType") == 6 ? allActiveProducts : activeProducts,
      supplierList: [],
      logisticsCompanies: LOGISTICS_COMPANIES.slice(),
      params: {
        productType: "",
        supplierId: "",
        logisticsCompany: "",
        logisticsNo: "",
        waybillNo: "",
        receiveStatus: "",
        beginIndex: 0,
        pageSize: 50,
      },
      addDialogVisible: false,
      dialogMode: "add",
      addSaving: false,
      proofUploadPending: 0,
      barcodeRecognizingPending: 0,
      pasteTarget: "supplier",
      addForm: createEmptyLogisticsForm(),
      addRules: {
        orderNo: [{ required: true, message: "请填写采购单号", trigger: "blur" }],
        date: [{ required: true, message: "请选择采购日期", trigger: "change" }],
        supplierId: [{ required: true, message: "请选择供应商", trigger: "change" }],
        logisticsCompany: [{ required: true, message: "请选择物流公司", trigger: "change" }],
      },
      receiveUploadDialogVisible: false,
      receiveUploadProcessing: false,
      receiveUploadPendingFiles: [],
      receiveUploadResults: [],
      receiveUploadPasteActive: false,
      matchConfirmVisible: false,
      matchConfirmRematching: false,
      matchConfirmContext: createEmptyMatchConfirmContext(),
      matchConfirmResolver: null,
      opreateLogVisible: false,
      opreateLogLoading: false,
      operateHistory: [],
    };
  },
  computed: {
    proofUploading() {
      return this.proofUploadPending > 0;
    },
    barcodeRecognizing() {
      return this.barcodeRecognizingPending > 0;
    },
    supplierPanelLoading() {
      return this.proofUploading || this.barcodeRecognizing;
    },
  },
  activated() {
    this.calcTableHeight();
    this.fetchSuppliers();
    this.fetchData();
  },
  mounted() {
    this.calcTableHeight();
    window.addEventListener("resize", this.calcTableHeight);
    this.fetchSuppliers();
    this.fetchData();
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.calcTableHeight);
    document.removeEventListener("paste", this.handleDialogPaste);
    document.removeEventListener("paste", this.handleReceiveUploadPaste);
    this.revokeReceivePendingPreviews();
    this.revokeReceiveResultPreviews();
  },
  methods: {
    calcTableHeight() {
      this.$nextTick(() => {
        const panel = this.$refs.tablePanel;
        if (!panel) return;
        const pagination = panel.querySelector(".pagination-box");
        const panelStyle = window.getComputedStyle(panel);
        const paddingTop = parseFloat(panelStyle.paddingTop) || 0;
        const paddingBottom = parseFloat(panelStyle.paddingBottom) || 0;
        const paginationHeight = pagination ? pagination.offsetHeight : 52;
        const available = panel.clientHeight - paddingTop - paddingBottom - paginationHeight;
        this.screenHeight = Math.max(available, 200);
        this.$nextTick(() => {
          if (this.$refs.table && this.$refs.table.doLayout) {
            this.$refs.table.doLayout();
          }
        });
      });
    },
    formatAmount(value) {
      if (value === "" || value === null || value === undefined) return "-";
      const num = parseFloat(value);
      if (Number.isNaN(num)) return "-";
      return num.toFixed(2);
    },
    formatQuantity(value) {
      if (value === "" || value === null || value === undefined) return "-";
      const num = parseInt(value, 10);
      if (Number.isNaN(num)) return "-";
      return String(num);
    },
    getTableRowKey(row) {
      return row._tableRowKey || `${row._id || row.logisticsId || "logistic"}-${row._lineIndex || 0}`;
    },
    getLogisticsRowIndex(row) {
      let orderIndex = 0;
      const targetId = String((row && (row.logisticsId || row._id)) || "");
      for (let i = 0; i < this.tableData.length; i++) {
        if (this.tableData[i]._orderRowSpan > 0) {
          orderIndex++;
          if (String(this.tableData[i].logisticsId || this.tableData[i]._id) === targetId) {
            return this.params.beginIndex + orderIndex;
          }
        }
      }
      return "";
    },
    tableCellClassName({ column }) {
      const classNames = ["table-cell"];
      if (LOGISTICS_MERGE_PROPS.includes(column.property) || LOGISTICS_MERGE_LABELS.includes(column.label)) {
        classNames.push("merge-col");
      }
      return classNames.join(" ");
    },
    spanMethod({ row, column }) {
      if (LOGISTICS_MERGE_PROPS.includes(column.property) || LOGISTICS_MERGE_LABELS.includes(column.label)) {
        const rowspan = row._orderRowSpan || 0;
        return { rowspan, colspan: rowspan > 0 ? 1 : 0 };
      }
      return { rowspan: 1, colspan: 1 };
    },
    formatCreateTime(time) {
      if (!time) return "-";
      const date = new Date(Number(time));
      if (isNaN(date.getTime())) return "-";
      return date.format("yyyy-MM-dd hh:mm");
    },
    formatWaybillNos(row) {
      const list = normalizeWaybillNos((row && row.waybillNos) || (row && row.waybillNo));
      return list.length ? list.join("，") : "-";
    },
    getLogisticsNoList(row) {
      if (!row) return [];
      if (Array.isArray(row.logisticsNos) && row.logisticsNos.length) {
        return row.logisticsNos.map(item => String(item || "").trim()).filter(Boolean);
      }
      const label = String(row.logisticsNo || "").trim();
      if (!label) return [];
      return label
        .split(/[,，;；\s]+/)
        .map(item => item.trim())
        .filter(Boolean);
    },
    getImageList(value) {
      if (!value) return [];
      if (Array.isArray(value)) {
        return value.map(item => String(item || "").trim()).filter(Boolean);
      }
      if (typeof value === "string" && value.trim()) return [value.trim()];
      return [];
    },
    markProofUploadStart() {
      this.proofUploadPending += 1;
    },
    markProofUploadEnd() {
      this.proofUploadPending = Math.max(0, this.proofUploadPending - 1);
    },
    fetchSuppliers() {
      requestModules.fetchSuppliers({ beginIndex: 0, pageSize: 1000 }).then(res => {
        this.supplierList = (res && res.ldata) || [];
      });
    },
    buildQueryParams() {
      const query = {
        productType: this.params.productType === "" || this.params.productType == null ? "" : this.params.productType,
        supplierId: this.params.supplierId || "",
        logisticsCompany: this.params.logisticsCompany || "",
        logisticsNo: (this.params.logisticsNo || "").trim(),
        waybillNo: (this.params.waybillNo || "").trim(),
        receiveStatus:
          this.params.receiveStatus === "" || this.params.receiveStatus == null ? "" : this.params.receiveStatus,
        beginIndex: this.params.beginIndex,
        pageSize: this.params.pageSize,
      };
      if (this.dateRange && this.dateRange.length === 2) {
        query.beginDate = this.dateRange[0].format("yyyy-MM-dd");
        query.endDate = this.dateRange[1].format("yyyy-MM-dd");
      }
      return query;
    },
    queryBtn() {
      this.currentPage = 1;
      this.params.beginIndex = 0;
      this.fetchData();
    },
    onPageChange(page) {
      this.currentPage = page;
      this.params.beginIndex = (page - 1) * this.params.pageSize;
      this.fetchData();
    },
    fetchData() {
      this.loading = true;
      logisticsModules
        .fetchLogistics(this.buildQueryParams())
        .then(res => {
          this.tableData = (res && res.ldata) || [];
          this.total = (res && res.total) || 0;
          const companies = res && res.mdata && res.mdata.logisticsCompanies;
          if (Array.isArray(companies) && companies.length) {
            this.logisticsCompanies = companies;
          }
        })
        .finally(() => {
          this.loading = false;
          this.calcTableHeight();
        });
    },
    openAddDialog() {
      this.dialogMode = "add";
      this.addForm = createEmptyLogisticsForm();
      this.addDialogVisible = true;
      this.$nextTick(() => {
        if (this.$refs.addForm) this.$refs.addForm.clearValidate();
      });
    },
    resolveSupplierIdValue(supplierId) {
      if (supplierId === undefined || supplierId === null || supplierId === "") return "";
      const matched = (this.supplierList || []).find(item => String(item.supplierId) === String(supplierId));
      return matched ? matched.supplierId : supplierId;
    },
    openEditDialog(row) {
      if (!row || !row._id) {
        this.$message.error("无效的物流记录");
        return;
      }
      this.dialogMode = "edit";
      this.addForm = {
        _id: row._id,
        orderNo: row.orderNo || "",
        date: row.date || "",
        shopName: row.shopName || "",
        supplierId: this.resolveSupplierIdValue(row.supplierId),
        supplierName: row.supplierName || "",
        actualPaidAmount: row.actualPaidAmount === "" || row.actualPaidAmount == null ? "" : String(row.actualPaidAmount),
        purchaseOrderId: row.purchaseOrderId || "",
        source: row.source || "manual",
        productLines: normalizeProductLinesFromRow(row, this.productList),
        logisticsCompany: row.logisticsCompany || "",
        logisticsNos: normalizeStringList(
          row.logisticsNos && row.logisticsNos.length ? row.logisticsNos : row.logisticsNo
        ),
        boxCount: row.boxCount === "" || row.boxCount == null ? null : Number(row.boxCount),
        waybillNos: normalizeWaybillNos(row.waybillNos && row.waybillNos.length ? row.waybillNos : row.waybillNo),
        supplierWaybillPhotos: this.getImageList(row.supplierWaybillPhotos).slice(),
        receiveLogisticsImages: this.getImageList(row.receiveLogisticsImages).slice(),
        remark: row.remark || "",
      };
      if (!this.addForm.supplierName && this.addForm.supplierId !== "") {
        this.onAddSupplierChange(this.addForm.supplierId);
      }
      this.addDialogVisible = true;
      this.$nextTick(() => {
        if (this.$refs.addForm) this.$refs.addForm.clearValidate();
      });
    },
    showOpreateLog(row) {
      const logisticsId = row && (row.logisticsId || row._id);
      if (!logisticsId) {
        this.$message.warning("缺少物流记录ID");
        return;
      }
      this.operateHistory = [];
      this.opreateLogVisible = true;
      this.opreateLogLoading = true;
      requestModules
        .fetchOpreateLogs({
          startTime: 0,
          endTime: new Date().getTime(),
          bussinessId: logisticsId,
          beginIndex: 0,
          pageSize: 1000,
        })
        .then(res => {
          if (res.result !== 1) {
            this.$message.error(res.message || "获取操作记录失败");
            return;
          }
          this.operateHistory = res.ldata || [];
          if (!this.operateHistory.length) {
            this.$message.info("暂无操作记录");
          }
        })
        .catch(err => {
          this.$message.error((err && err.message) || "获取操作记录失败");
        })
        .finally(() => {
          this.opreateLogLoading = false;
        });
    },
    onAddDialogOpened() {
      this.pasteTarget = "supplier";
      document.addEventListener("paste", this.handleDialogPaste);
    },
    onAddDialogClosed() {
      document.removeEventListener("paste", this.handleDialogPaste);
      this.dialogMode = "add";
      this.pasteTarget = "supplier";
      this.addForm = createEmptyLogisticsForm();
      this.addSaving = false;
      this.proofUploadPending = 0;
      this.barcodeRecognizingPending = 0;
      if (this.$refs.addForm) this.$refs.addForm.clearValidate();
    },
    setPasteTarget(target) {
      this.pasteTarget = target === "receive" ? "receive" : "supplier";
    },
    collectClipboardImageFiles(event) {
      const items = event && event.clipboardData && event.clipboardData.items;
      if (!items || !items.length) return [];
      const files = [];
      for (let i = 0; i < items.length; i++) {
        const item = items[i];
        if (item.kind === "file" && item.type && item.type.indexOf("image/") === 0) {
          const file = item.getAsFile();
          if (file) files.push(file);
        }
      }
      return files;
    },
    handleDialogPaste(event) {
      if (!this.addDialogVisible) return;
      const files = this.collectClipboardImageFiles(event);
      if (!files.length) return;
      event.preventDefault();
      files.forEach(file => {
        if (this.pasteTarget === "supplier" && this.$refs.supplierWaybillPanel) {
          this.$refs.supplierWaybillPanel.uploadPastedFile(file);
        } else {
          this.uploadPastedReceiveImage(file);
        }
      });
    },
    uploadPastedReceiveImage(file) {
      if (!this.isProofImageFile(file)) {
        this.$message.error("请粘贴图片文件");
        return;
      }
      const formData = new FormData();
      formData.append("file", file);
      formData.append("bizModule", "logistic");
      this.markProofUploadStart();
      ossModules
        .upload(formData)
        .then(res => {
          if (res && res.objData && res.objData.fileUrl) {
            this.addForm.receiveLogisticsImages.push(res.objData.fileUrl);
            return;
          }
          this.$message.error((res && res.message) || "上传失败");
        })
        .catch(err => {
          this.$message.error((err && err.message) || "上传失败");
        })
        .finally(() => {
          this.markProofUploadEnd();
        });
    },
    onAddSupplierChange(supplierId) {
      const supplier = (this.supplierList || []).find(item => String(item.supplierId) === String(supplierId));
      this.addForm.supplierName = supplier
        ? supplier.supplierShortName || supplier.supplierName || ""
        : "";
    },
    isProofImageFile(file) {
      if (!file) return false;
      if (file.type && file.type.indexOf("image/") === 0) return true;
      const name = (file.name || "").toLowerCase();
      return /\.(jpg|jpeg|png|gif|webp|bmp)$/.test(name);
    },
    beforeReceiveLogisticsUpload(file) {
      if (!this.isProofImageFile(file)) {
        this.$message.error("请上传图片文件");
        return false;
      }
      this.markProofUploadStart();
      return true;
    },
    markBarcodeRecognizingStart() {
      this.barcodeRecognizingPending += 1;
    },
    markBarcodeRecognizingEnd() {
      this.barcodeRecognizingPending = Math.max(0, this.barcodeRecognizingPending - 1);
    },
    buildBarcodeRecognitionMessage(logisticsNos, logisticsCompanies) {
      const lines = [`识别到 ${logisticsNos.length} 个物流单号：`].concat(logisticsNos);
      const willFillCompany = logisticsCompanies.length === 1 && !this.addForm.logisticsCompany;

      if (willFillCompany) {
        lines.push("", `物流公司：${logisticsCompanies[0]}（确认后将自动填入）`);
      } else if (logisticsCompanies.length > 1) {
        lines.push("", "检测到多个物流公司，确认单号后请手动选择物流公司。");
      } else if (this.addForm.logisticsCompany) {
        lines.push("", `当前物流公司：${this.addForm.logisticsCompany}（不会修改）`);
      } else {
        lines.push("", "未能匹配物流公司，确认单号后请手动选择。");
      }

      return lines.join("\n");
    },
    applyBarcodeRecognition(result) {
      const logisticsNos = normalizeStringList(result && result.logisticsNos);
      const logisticsCompanies = normalizeStringList(result && result.logisticsCompanies);

      if (!logisticsNos.length) {
        return this.$alert(
          "未能从面单照片中识别到物流单号，请检查图片是否清晰、条形码是否完整，或手动填写物流单号后重新上传。",
          "面单识别结果",
          {
            confirmButtonText: "知道了",
            type: "warning",
            customClass: "barcode-recognition-confirm",
          }
        ).catch(() => {});
      }

      const willFillCompany = logisticsCompanies.length === 1 && !this.addForm.logisticsCompany;

      return this.$confirm(this.buildBarcodeRecognitionMessage(logisticsNos, logisticsCompanies), "面单识别结果", {
        confirmButtonText: "确认填入",
        cancelButtonText: "取消",
        type: "info",
        customClass: "barcode-recognition-confirm",
      })
        .then(() => {
          this.addForm.logisticsNos = normalizeStringList([...this.addForm.logisticsNos, ...logisticsNos]);
          if (willFillCompany) {
            this.addForm.logisticsCompany = logisticsCompanies[0];
          }
          this.$message.success(`已填入 ${logisticsNos.length} 个物流单号`);
        })
        .catch(() => {});
    },
    handleReceiveLogisticsUploadSuccess(res) {
      this.markProofUploadEnd();
      if (res && res.objData && res.objData.fileUrl) {
        this.addForm.receiveLogisticsImages.push(res.objData.fileUrl);
        return;
      }
      this.$message.error((res && res.message) || "上传失败");
    },
    handleProofUploadError() {
      this.markProofUploadEnd();
      this.$message.error("上传失败");
    },
    buildSubmitPayload() {
      const waybillNos = normalizeWaybillNos(this.addForm.waybillNos);
      const logisticsNos = normalizeStringList(this.addForm.logisticsNos);
      const payload = {
        orderNo: (this.addForm.orderNo || "").trim(),
        date: this.addForm.date || "",
        shopName: (this.addForm.shopName || "").trim(),
        supplierId: this.addForm.supplierId,
        supplierName: this.addForm.supplierName || "",
        actualPaidAmount: this.addForm.actualPaidAmount,
        purchaseOrderId: this.addForm.purchaseOrderId || "",
        source: this.addForm.source || "manual",
        productLines: serializeProductLinesForSubmit(this.addForm.productLines),
        logisticsCompany: this.addForm.logisticsCompany || "",
        logisticsNos: JSON.stringify(logisticsNos),
        boxCount: this.addForm.boxCount == null || this.addForm.boxCount === "" ? "" : this.addForm.boxCount,
        waybillNos: JSON.stringify(waybillNos),
        supplierWaybillPhotos: JSON.stringify(this.addForm.supplierWaybillPhotos || []),
        receiveLogisticsImages: JSON.stringify(this.addForm.receiveLogisticsImages || []),
        remark: (this.addForm.remark || "").trim(),
      };
      if (this.dialogMode === "edit") {
        payload._id = this.addForm._id;
      }
      return payload;
    },
    async checkDuplicateLogisticsHint(logisticsNos) {
      const hints = [];
      for (let i = 0; i < logisticsNos.length; i++) {
        const no = logisticsNos[i];
        const res = await logisticsModules.findLogisticsByNo({ logisticsNo: no });
        const count = res && res.mdata && res.mdata.matchCount != null ? res.mdata.matchCount : (res.ldata || []).length;
        if (count > 0) {
          hints.push(`物流单号 ${no} 已有 ${count} 条记录`);
        }
      }
      if (!hints.length) return true;
      try {
        await this.$confirm(`${hints.join("\n")}\n\n是否仍继续${this.dialogMode === "edit" ? "保存" : "新建"}？`, "重复物流单号提示", {
          confirmButtonText: "继续",
          cancelButtonText: "取消",
          type: "info",
        });
        return true;
      } catch (e) {
        return false;
      }
    },
    submitForm() {
      const lineError =
        (this.$refs.productLinesEditor && this.$refs.productLinesEditor.validate()) ||
        "";
      if (lineError) {
        this.$message.warning(lineError);
        return;
      }
      const logisticsNos = normalizeStringList(this.addForm.logisticsNos);
      if (!logisticsNos.length) {
        this.$message.warning("请填写或识别物流单号");
        return;
      }
      this.$refs.addForm.validate(async valid => {
        if (!valid) return;
        const canContinue = await this.checkDuplicateLogisticsHint(logisticsNos);
        if (!canContinue) return;
        const isEdit = this.dialogMode === "edit";
        this.addSaving = true;
        const request = isEdit
          ? logisticsModules.updateLogistics(this.buildSubmitPayload())
          : logisticsModules.addLogistics(this.buildSubmitPayload());
        request
          .then(res => {
            if (!res || res.result !== 1) {
              this.$message.error((res && res.message) || (isEdit ? "更新失败" : "新增失败"));
              return;
            }
            this.$message.success(isEdit ? "更新成功" : "新增成功");
            this.addDialogVisible = false;
            if (isEdit) {
              this.fetchData();
            } else {
              this.queryBtn();
            }
          })
          .catch(err => {
            this.$message.error((err && err.message) || (isEdit ? "更新失败" : "新增失败"));
          })
          .finally(() => {
            this.addSaving = false;
          });
      });
    },
    openReceiveUploadDialog() {
      this.receiveUploadPendingFiles = [];
      this.receiveUploadResults = [];
      this.receiveUploadProcessing = false;
      this.receiveUploadDialogVisible = true;
    },
    onReceiveUploadDialogOpened() {
      this.receiveUploadPasteActive = true;
      document.addEventListener("paste", this.handleReceiveUploadPaste);
    },
    onReceiveUploadDialogClosed() {
      document.removeEventListener("paste", this.handleReceiveUploadPaste);
      this.receiveUploadProcessing = false;
      this.receiveUploadPasteActive = false;
      this.revokeReceivePendingPreviews();
    },
    revokeObjectUrl(url) {
      if (url && String(url).indexOf("blob:") === 0) {
        URL.revokeObjectURL(url);
      }
    },
    revokeReceivePendingPreviews() {
      (this.receiveUploadPendingFiles || []).forEach(item => {
        this.revokeObjectUrl(item.previewUrl);
      });
      this.receiveUploadPendingFiles = [];
    },
    revokeReceiveResultPreviews() {
      (this.receiveUploadResults || []).forEach(item => {
        this.revokeObjectUrl(item.previewUrl);
      });
    },
    appendReceivePendingFile(file) {
      if (!this.isProofImageFile(file)) {
        this.$message.error("请上传图片文件");
        return;
      }
      const uid = `${Date.now()}-${Math.random()}`;
      this.receiveUploadPendingFiles.push({
        uid,
        name: file.name || "粘贴图片",
        file,
        previewUrl: URL.createObjectURL(file),
      });
    },
    onReceiveFileChange(file) {
      if (!file || !file.raw) return;
      this.appendReceivePendingFile(file.raw);
    },
    removeReceivePendingFile(index) {
      const item = this.receiveUploadPendingFiles[index];
      if (item) this.revokeObjectUrl(item.previewUrl);
      this.receiveUploadPendingFiles.splice(index, 1);
    },
    handleReceiveUploadPaste(event) {
      if (!this.receiveUploadDialogVisible || this.receiveUploadProcessing) return;
      const files = this.collectClipboardImageFiles(event);
      if (!files.length) return;
      event.preventDefault();
      files.forEach(file => this.appendReceivePendingFile(file));
    },
    async fetchMatchListByNo(logisticsNo) {
      const no = String(logisticsNo || "").trim();
      if (!no) return [];
      const res = await logisticsModules.findLogisticsByNo({ logisticsNo: no });
      if (!res || res.result !== 1) {
        throw new Error((res && res.message) || "查询匹配记录失败");
      }
      return (res.ldata || []).slice();
    },
    uploadReceiveImageFile(file) {
      const formData = new FormData();
      formData.append("file", file);
      formData.append("bizModule", "logistic");
      return ossModules.upload(formData).then(res => {
        if (res && res.objData && res.objData.fileUrl) return res.objData.fileUrl;
        throw new Error((res && res.message) || "上传失败");
      });
    },
    async recognizeLogisticsNoFromFile(file) {
      try {
        const { scanLogisticsBarcodesFromFile } = await import("../../utils/logisticsBarcodeScanner");
        const result = await scanLogisticsBarcodesFromFile(file);
        const list = normalizeStringList(result && result.logisticsNos);
        return list.length ? list[0] : "";
      } catch (e) {
        return "";
      }
    },
    openMatchConfirmDialog(context) {
      this.matchConfirmContext = {
        ...createEmptyMatchConfirmContext(),
        ...context,
        matchList: (context.matchList || []).slice(),
      };
      this.matchConfirmVisible = true;
      return new Promise(resolve => {
        this.matchConfirmResolver = resolve;
      });
    },
    resolveMatchConfirm(result) {
      if (this.matchConfirmResolver) {
        this.matchConfirmResolver(result);
        this.matchConfirmResolver = null;
      }
      this.matchConfirmVisible = false;
    },
    onMatchConfirmDialogClosed() {
      if (this.matchConfirmResolver) {
        this.matchConfirmResolver({ confirmed: false });
        this.matchConfirmResolver = null;
      }
      this.matchConfirmContext = createEmptyMatchConfirmContext();
      this.matchConfirmRematching = false;
    },
    onMatchConfirmSkip() {
      this.resolveMatchConfirm({ confirmed: false });
    },
    onMatchConfirmConfirm() {
      const ctx = this.matchConfirmContext;
      if (!ctx.matchList.length) return;
      this.resolveMatchConfirm({
        confirmed: true,
        logisticsNo: String(ctx.logisticsNo || "").trim(),
        matchList: ctx.matchList.slice(),
      });
    },
    async onMatchConfirmRematch() {
      const no = String(this.matchConfirmContext.logisticsNo || "").trim();
      if (!no) {
        this.$message.warning("请输入物流单号");
        return;
      }
      this.matchConfirmRematching = true;
      try {
        const matchList = await this.fetchMatchListByNo(no);
        this.matchConfirmContext.logisticsNo = no;
        this.matchConfirmContext.matchList = matchList;
      } catch (err) {
        this.$message.error((err && err.message) || "重新匹配失败");
      } finally {
        this.matchConfirmRematching = false;
      }
    },
    buildReceiveUploadResultRow(payload) {
      return {
        previewUrl: payload.previewUrl || "",
        logisticsNo: payload.logisticsNo || "-",
        matchCount: payload.matchCount != null ? payload.matchCount : 0,
        appendedCount: payload.appendedCount != null ? payload.appendedCount : 0,
        statusLabel: payload.statusLabel || "-",
        message: payload.message || "",
      };
    },
    async startReceiveUploadProcess() {
      if (!this.receiveUploadPendingFiles.length || this.receiveUploadProcessing) return;
      const files = this.receiveUploadPendingFiles.slice();
      this.receiveUploadProcessing = true;
      this.receiveUploadResults = [];
      let needRefresh = false;

      for (let i = 0; i < files.length; i++) {
        const item = files[i];
        const file = item.file;
        const previewUrl = item.previewUrl;
        try {
          const imageUrl = await this.uploadReceiveImageFile(file);
          const recognizedNo = await this.recognizeLogisticsNoFromFile(file);
          let matchList = [];
          if (recognizedNo) {
            matchList = await this.fetchMatchListByNo(recognizedNo);
          }

          const confirmResult = await this.openMatchConfirmDialog({
            imageUrl,
            previewUrl,
            logisticsNo: recognizedNo,
            matchList,
            index: i + 1,
            total: files.length,
          });

          if (!confirmResult || !confirmResult.confirmed) {
            this.receiveUploadResults.push(
              this.buildReceiveUploadResultRow({
                previewUrl,
                logisticsNo: recognizedNo || (confirmResult && confirmResult.logisticsNo) || "-",
                matchCount: matchList.length,
                appendedCount: 0,
                statusLabel: "已跳过",
                message: "用户跳过本张",
              })
            );
            continue;
          }

          const finalNo = confirmResult.logisticsNo;
          const finalMatches = confirmResult.matchList || [];
          if (!finalMatches.length) {
            this.receiveUploadResults.push(
              this.buildReceiveUploadResultRow({
                previewUrl,
                logisticsNo: finalNo || "-",
                matchCount: 0,
                appendedCount: 0,
                statusLabel: "未匹配",
                message: "无可用匹配记录",
              })
            );
            continue;
          }

          const appendRes = await logisticsModules.batchAppendReceiveLogisticsImages({
            ids: JSON.stringify(finalMatches.map(row => row._id)),
            imageUrl,
            logisticsNo: finalNo,
          });

          if (!appendRes || appendRes.result !== 1) {
            this.receiveUploadResults.push(
              this.buildReceiveUploadResultRow({
                previewUrl,
                logisticsNo: finalNo,
                matchCount: finalMatches.length,
                appendedCount: 0,
                statusLabel: "失败",
                message: (appendRes && appendRes.message) || "追加失败",
              })
            );
            continue;
          }

          const appendedCount =
            (appendRes.mdata && appendRes.mdata.appendedCount) || (appendRes.ldata && appendRes.ldata.length) || 0;
          needRefresh = true;
          this.receiveUploadResults.push(
            this.buildReceiveUploadResultRow({
              previewUrl,
              logisticsNo: finalNo,
              matchCount: finalMatches.length,
              appendedCount,
              statusLabel: appendedCount === finalMatches.length ? "已追加" : "部分成功",
              message: appendRes.message || `已追加到 ${appendedCount} 条记录`,
            })
          );
        } catch (err) {
          this.receiveUploadResults.push(
            this.buildReceiveUploadResultRow({
              previewUrl,
              logisticsNo: "-",
              matchCount: 0,
              appendedCount: 0,
              statusLabel: "失败",
              message: (err && err.message) || "处理失败",
            })
          );
        }
      }

      this.revokeReceivePendingPreviews();
      this.receiveUploadProcessing = false;
      if (needRefresh) this.fetchData();
    },
  },
};
</script>

<style lang="scss">
@import "../../assets/styles/purchaseMgmtPage.scss";

#LogisticsMgmt {
  .table-panel {
    position: relative;
  }

  .table-container {
    overflow: hidden;
  }

  .pagination-box {
    position: relative;
    z-index: 20;
    background: #fff;
    flex-shrink: 0;
    min-height: 44px;
    align-items: center;
  }

  .proof-thumb-list {
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    gap: 4px;
  }

  .proof-thumb {
    width: 36px;
    height: 36px;
    border-radius: 4px;
    border: 1px solid #ebeef5;
  }

  .proof-empty {
    color: #c0c4cc;
  }

  .action-cell {
    display: inline-flex;
    flex-wrap: wrap;
    justify-content: center;
    gap: 0 4px;
  }

  .mgmt-table {
    .el-table__body td.logistics-no-col {
      vertical-align: top;
    }

    .el-table__body td.logistics-no-col .cell {
      white-space: normal !important;
      overflow: visible !important;
      text-overflow: clip !important;
      line-height: 1.35;
      height: auto !important;
    }

    .logistics-no-list {
      display: flex;
      flex-direction: column;
      gap: 4px;
      padding: 4px 0;
      align-items: flex-start;
    }

    .logistics-no-item {
      word-break: break-all;
      white-space: normal;
      line-height: 1.35;
    }

    .el-table__body tr,
    .el-table__fixed .el-table__body tr,
    .el-table__fixed-right .el-table__body tr {
      height: auto;
      min-height: 36px;
    }

    /* 固定列高度与主表对齐，避免盖住分页 */
    .el-table__fixed,
    .el-table__fixed-right {
      height: 100% !important;
      bottom: 0 !important;
      overflow: hidden;
    }

    .el-table__fixed-body-wrapper,
    .el-table__fixed-right .el-table__fixed-body-wrapper {
      max-height: none !important;
    }
  }
}

.logistics-add-dialog {
  .box-count-input {
    .el-input__inner {
      text-align: left;
    }
  }

  .proof-upload-panel {
    outline: none;
    border: 1px dashed transparent;
    border-radius: 6px;
    padding: 4px;
  }

  .proof-upload-panel.is-paste-active {
    border-color: #409eff;
    background: #f5f9ff;
  }

  .proof-upload-panel:focus {
    box-shadow: none;
  }

  .proof-upload-list {
    display: flex;
    flex-wrap: wrap;
    gap: 12px;
  }

  .proof-upload-item {
    position: relative;
    width: 96px;
    height: 96px;
    border: 1px solid #ebeef5;
    border-radius: 6px;
    overflow: hidden;
  }

  .proof-upload-image {
    width: 100%;
    height: 100%;
  }

  .proof-upload-remove {
    position: absolute;
    top: 2px;
    right: 2px;
    color: #f56c6c;
    font-size: 18px;
    cursor: pointer;
    background: rgba(255, 255, 255, 0.9);
    border-radius: 50%;
  }

  .proof-upload-add .el-upload {
    width: 96px;
    height: 96px;
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
  }

  .proof-upload-trigger {
    width: 96px;
    height: 96px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    color: #909399;
    font-size: 12px;
  }

  .proof-upload-trigger .el-icon-plus {
    font-size: 20px;
    margin-bottom: 4px;
  }

  .proof-upload-tip,
  .form-item-tip {
    margin-top: 8px;
    color: #909399;
    font-size: 12px;
    line-height: 1.4;
  }
}

.barcode-recognition-confirm .el-message-box__message {
  white-space: pre-wrap;
  line-height: 1.6;
  max-height: 320px;
  overflow-y: auto;
}

.receive-upload-dialog,
.receive-match-dialog {
  .receive-upload-panel {
    outline: none;
  }

  .receive-upload-tip {
    margin-left: 12px;
    color: #909399;
    font-size: 12px;
  }

  .receive-pending-list {
    display: flex;
    flex-wrap: wrap;
    gap: 12px;
    margin-top: 16px;
  }

  .receive-pending-item {
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 96px;
  }

  .receive-pending-thumb,
  .receive-result-thumb,
  .receive-match-thumb {
    width: 64px;
    height: 64px;
    border-radius: 4px;
    border: 1px solid #ebeef5;
  }

  .receive-pending-name {
    margin-top: 4px;
    font-size: 12px;
    color: #606266;
    max-width: 96px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  .receive-result-section {
    margin-top: 16px;
  }

  .receive-result-title {
    margin-bottom: 8px;
    font-size: 13px;
    color: #303133;
    font-weight: 500;
  }

  .receive-match-summary {
    display: flex;
    gap: 16px;
    margin-bottom: 12px;
  }

  .receive-match-meta {
    flex: 1;
    min-width: 0;
  }

  .receive-match-progress {
    margin-bottom: 8px;
    color: #606266;
    font-size: 13px;
  }

  .receive-match-tip {
    margin-top: 4px;
    color: #606266;
    font-size: 12px;
    line-height: 1.5;
  }

  .receive-match-tip.is-warning {
    color: #e6a23c;
  }
}
</style>
